import React, { useState } from 'react';
import { Plus, Edit2, Trash2 } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import Modal from '../../components/common/Modal';
import Badge from '../../components/common/Badge';
import { generateId, formatDate } from '../../utils/helpers';

function VehicleList() {
  const { vehicles, setVehicles, staff } = useApp();
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ registrationNumber:'', type:'Bus', capacity:'', driverId:'', insuranceExpiry:'', status:'active' });
  const [editing, setEditing] = useState(null);

  const openAdd = () => { setForm({ registrationNumber:'', type:'Bus', capacity:'', driverId:'', insuranceExpiry:'', status:'active' }); setEditing(null); setModal(true); };
  const openEdit = (v) => { setForm(v); setEditing(v); setModal(true); };
  const remove = (id) => { if(window.confirm('Delete vehicle?')) setVehicles(prev=>prev.filter(v=>v.id!==id)); };
  const save = () => {
    if(editing) setVehicles(prev=>prev.map(v=>v.id===editing.id?{...form,id:editing.id}:v));
    else setVehicles(prev=>[...prev,{...form,id:generateId('VEH')}]);
    setModal(false);
  };
  const getDriver = (id) => { const s=staff.find(s=>s.id===id); return s?`${s.firstName} ${s.lastName}`:'-'; };

  const columns_data = vehicles.map(v=>({...v, driverName:getDriver(v.driverId)}));

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="text-2xl font-bold">Vehicles</h1><p className="text-gray-500 text-sm">{vehicles.length} vehicles</p></div>
        <button onClick={openAdd} className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-1 rounded-lg text-sm font-medium"><Plus size={16}/>Add Vehicle</button>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-100">
              {['Registration No','Type','Capacity','Driver','Insurance Expiry','Status'].map(h=>(
                <th key={h} className="px-4 py-1 text-left font-semibold">{h}</th>
              ))}
              <th className="px-4 py-1 text-left font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {vehicles.map(v=>(
              <tr key={v.id} className="hover:bg-gray-50">
                <td className="px-4 py-1 font-medium">{v.registrationNumber}</td>
                <td className="px-4 py-1">{v.type}</td>
                <td className="px-4 py-1">{v.capacity}</td>
                <td className="px-4 py-1">{getDriver(v.driverId)}</td>
                <td className="px-4 py-1">{formatDate(v.insuranceExpiry)}</td>
                <td className="px-4 py-1"><Badge value={v.status}/></td>
                <td className="px-4 py-1">
                  <div className="flex gap-1">
                    <button onClick={()=>openEdit(v)} className="p-1.5 hover:bg-indigo-50 rounded-lg text-indigo-600"><Edit2 size={15}/></button>
                    <button onClick={()=>remove(v.id)} className="p-1.5 hover:bg-red-50 rounded-lg text-red-500"><Trash2 size={15}/></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Modal isOpen={modal} onClose={()=>setModal(false)} title={editing?'Edit Vehicle':'Add Vehicle'}>
        <div className="space-y-3">
          {[['Registration No','registrationNumber'],['Capacity','capacity']].map(([label,key])=>(
            <div key={key}>
              <label className="block text-sm font-medium mb-1">{label}</label>
              <input value={form[key]||''} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300" />
            </div>
          ))}
          <div>
            <label className="block text-sm font-medium mb-1">Type</label>
            <select value={form.type||'Bus'} onChange={e=>setForm(f=>({...f,type:e.target.value}))} className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300">
              {['Bus','Mini Bus','Van','Auto'].map(t=><option key={t}>{t}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Driver</label>
            <select value={form.driverId||''} onChange={e=>setForm(f=>({...f,driverId:e.target.value}))} className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300">
              <option value="">Select Driver</option>
              {staff.filter(s=>s.designation==='Driver').map(s=><option key={s.id} value={s.id}>{s.firstName} {s.lastName}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Insurance Expiry</label>
            <input type="date" value={form.insuranceExpiry||''} onChange={e=>setForm(f=>({...f,insuranceExpiry:e.target.value}))} className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Status</label>
            <select value={form.status||'active'} onChange={e=>setForm(f=>({...f,status:e.target.value}))} className="w-full px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300">
              {['active','maintenance','inactive'].map(s=><option key={s}>{s}</option>)}
            </select>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-4 pt-4 border-t">
          <button onClick={()=>setModal(false)} className="px-4 py-1 text-sm hover:bg-gray-100 rounded-lg">Cancel</button>
          <button onClick={save} className="px-4 py-1 text-sm bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">Save</button>
        </div>
      </Modal>
    </div>
  );
}
export default VehicleList;
